import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Milestones</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2022 - present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Competition, Custom Fields and AI Sales</h3>
            <h4 className="vertical-timeline-element-subtitle">RepCard, USA</h4>
            <p>
              Developed Competition, Custom Fields, and AI Sales features for RepCard—driving engagement through friendly contests, enabling tailored data capture for diverse sales workflows, and leveraging AI to deliver smart insights that help reps close deals faster.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2020 - 2022"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Leaderboard, Chat and Calendar</h3>
            <h4 className="vertical-timeline-element-subtitle">RepCard, USA</h4>
            <p>
             Developed Leaderboard, Chat, and Calendar features for RepCard—showcasing real-time sales achievements to spark healthy competition, enabling instant and organized team communication, and streamlining appointment management with integrated scheduling, calendar sync, and automated reminders to maximize productivity.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2021 - 2021"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Canvassing</h3>
            <h4 className="vertical-timeline-element-subtitle">RepCard, USA</h4>
            <p>
              Developed a canvassing tool for field sales teams, enabling route planning, real-time tracking, and access to lead data to optimize outreach and productivity.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2020 - 2020"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Digital Business Profile</h3>
            <h4 className="vertical-timeline-element-subtitle">RepCard, USA</h4>
            <p>
              Developed a digital business profile platform using native mobile technologies like Swift and Kotlin, enabling businesses to showcase their services and collect customer reviews.
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;